import {action, observable} from 'mobx';
import _ from 'lodash';class VimeoVideo {

  @observable scrollTo = -1;

  @observable endTime = -1;

  @action
  scrollVideoTo = (time, endtime) => {
    this.scrollTo = _.assign(time);
    this.endTime = _.assign(endtime);
  };

  @action
  setEndTime = time => {
    this.endTime = _.assign(time);
  }


}
export default new VimeoVideo();



// WEBPACK FOOTER //
// ./src/stores/VimeoVideo.js